import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WebappService } from '../../../../shared/services/webapp.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'mobo-campaign-detail',
  templateUrl: './campaign-detail.component.html',
  styles: [],
})
export class CampaignDetailComponent {
  public campaign!: any;
  public restaurant!: any;
  public defaultImg = environment.defaultImg;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public webappService: WebappService
  ) {}

  ngOnInit() {
    this.route.params.subscribe((param) => {
      const campaignId = param['id'];
      this.getCampaignById(campaignId);
    });
  }

  async getCampaignById(campaignId: string) {
    this.campaign = await this.webappService.getCampaign(campaignId);
    if (!this.webappService.isBrowser) return;
    if (this.campaign.error) {
      this.router.navigate(['']);
      return;
    }
    this.getRestaurantById(this.campaign.CommercialPlaceId);
    this.getCityIfNeeded(this.campaign.CityId);
  }

  async getRestaurantById(restaurantId: string) {
    this.restaurant = await this.webappService.getRestaurant(restaurantId);
  }

  getCityIfNeeded(cityId: string) {
    let currentCity = this.webappService.selectedCity.value;
    if (currentCity != cityId) {
      this.webappService.selectedCity.next(cityId);
    }
  }

  public redirectToRestaurant() {
    this.router.navigate(['/restaurante', this.restaurant?.SluggedTradeName]);
  }
}
